import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'components/Button';

// <editor-fold desc="GeneralIntro type definitions ...">

export type GeneralIntroProps = {
  title?: string;
  description?: string;
};
// </editor-fold>

// <editor-fold desc="GeneralIntro component definition ...">
const GeneralIntro = ({
  title = '',
  description = '',
}: GeneralIntroProps): JSX.Element => {
  const { t } = useTranslation();
  const safeTitle = String(title ?? '');
  const safeDescription = String(description ?? '');

  return (
    <Container>
      <Row>
        <Col xs={12} className="p-4">
          <h2 className="text-primary">{safeTitle}</h2>
          <p>{safeDescription}</p>
          <Button href="https://www.tiitus.com/wiki/" target="_blank">
            {String(t('Ohjeet'))}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
// </editor-fold>

export default GeneralIntro;
